import { IsIn, IsNotEmpty, IsNumber, IsOptional, IsString, Min } from "class-validator";
import { Constants } from "@eagerdog/constants";

export class TransactionUpdateDto {
  @IsNotEmpty()
  @IsIn(Object.values(Constants.payment_method_type))
  payment_method_type: string;

  @IsOptional()
  cheque_number?: string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  total_amount?: number;

  @IsOptional()
  @IsString()
  override_note?: string;
} 